import { useMutation } from 'react-query';

import { useAPI } from '../../../hooks/useAPI';

export const Api = {
    useUpload: () => {
        const { Upscore } = useAPI();

        return useMutation((data: any) =>
            Upscore.postSourceTaxdataUpload(data),
        );
    },

    useExtract: () => {
        const { Upscore } = useAPI();

        return useMutation(() =>
            Upscore.postSourceTaxdataExtract({
                credentials: JSON.stringify({
                    loginMethod: 'idporten',
                }),
            }),
        );
    },

    useProgress: () => {
        const { Upscore } = useAPI();

        return useMutation(Upscore.getProgressUpdate);
    },
};
